// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: mediumThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.findyourrace_card {
  width: 305px;
  height: 339px;
  flex-shrink: 0;
  background: #1e1e1e;
  box-shadow: 0px 0px 62px -6px rgba(0, 0, 0, 0.15);
  padding: 16px;
}

.findyourrace_card_img_div {
  width: 100%;
  height: 229px;
}

.findyourrace_card_img_div > img {
  width: 100%;
  height: 100%;
}

.findyourrace_card_title {
  color: #fff;
  font-family: Thicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  text-transform: capitalize;
  margin-top: 12px;
}

.findyourrace_card_date {
  color: #fff;
  font-family: mediumThicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  text-transform: capitalize;
  margin-top: 8px;
}

.findyourrace_card_btns {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: none;
  margin-top: 16px;
}

.findyourrace_card_btns > button {
  display: flex;
  width: 131px !important;
  height: 40px;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: #000;
  font-family: mediumThicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #fff;
  cursor: pointer;
}

.findyourrace_card_btns > a {
  width: 131px !important;
  height: 40px;
  list-style: none;
  text-decoration: none;
}

.findyourrace_card_btns > a > button {
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
  color: #fff;
  background:#BA1E24;
  font-family: mediumThicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #BA1E24;
  cursor: pointer;
}

.findyourrace_card:hover .findyourrace_card_img_div {
  height: 225px !important;
  transition: all .2s linear;

}

.findyourrace_card:hover .findyourrace_card_btns {
  display: flex;
  margin-top: 12px;
  transition: all .2s linear;

}

.findyourrace_card:hover .findyourrace_card_date {
  display: none;
  transition: all .2s linear;

}












@media screen and (max-width: 1024px) {

  .findyourrace_card {
    width: 305px;
    height: 100%;
    padding: 16px;
  }
  
  .findyourrace_card_img_div {
    height: 229px;
  }
  
  .findyourrace_card_title {
    font-size: 20px;
    margin-top: 12px;
  }
  
  .findyourrace_card_date {
    font-size: 16px;
    margin-top: 8px;
  }
  
  .findyourrace_card_btns {
    width: 100%;
    justify-content: space-between;
    display: flex;
  }
  
  .findyourrace_card_btns > button {
    width: 131px !important;
    height: 40px;
    font-size: 16px;
  }
  
  .findyourrace_card_btns > a {
    width: 131px !important;
    height: 40px;
  }
  
  .findyourrace_card_btns > a > button {
    height: 40px;
    font-size: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_img_div {
    height: 229px !important;
  }
  
  .findyourrace_card:hover .findyourrace_card_btns {
    margin-top: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_date {
    display: flex;
  }

}












@media screen and (max-width: 800px) {

  .findyourrace_card {
    width: 300px;
    height: 100%;
    padding: 12px;
  }
  
  .findyourrace_card_img_div {
    height: 229px;
  }
  
  .findyourrace_card_title {
    font-size: 20px;
    margin-top: 12px;
  }
  
  .findyourrace_card_date {
    font-size: 16px;
    margin-top: 8px;
  }
  
  .findyourrace_card_btns {
    width: 100%;
    justify-content: space-between;
    display: flex;
    margin-bottom: 10px;
  }
  
  .findyourrace_card_btns > button {
    width: 131px !important;
    height: 40px;
    font-size: 16px;
  }
  
  .findyourrace_card_btns > a {
    width: 131px !important;
    height: 40px;
  }
  
  .findyourrace_card_btns > a > button {
    height: 40px;
    font-size: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_img_div {
    height: 229px !important;
  }
  
  .findyourrace_card:hover .findyourrace_card_btns {
    margin-top: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_date {
    display: flex;
  }

}



















@media screen and (max-width: 700px) {

  .findyourrace_card {
    width: 300px;
    height: 100%;
    padding: 12px;
  }
  
  .findyourrace_card_img_div {
    height: 229px;
  }
  
  .findyourrace_card_title {
    font-size: 20px;
    margin-top: 12px;
  }
  
  .findyourrace_card_date {
    font-size: 16px;
    margin-top: 8px;
  }
  
  .findyourrace_card_btns {
    width: 100%;
    justify-content: space-between;
    display: flex;
    margin-bottom: 10px;
  }
  
  .findyourrace_card_btns > button {
    width: 48% !important;
    height: 36px;
    font-size: 14px;
  }
  
  .findyourrace_card_btns > a {
    width: 48% !important;
    height: 36px;
  }
  
  .findyourrace_card_btns > a > button {
    height: 36px;
    font-size: 14px;
  }
  
  .findyourrace_card:hover .findyourrace_card_img_div {
    height: 229px !important;
  }
  
  .findyourrace_card:hover .findyourrace_card_btns {
    margin-top: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_date {
    display: flex;
  }

}











@media screen and (max-width: 600px) {

  .findyourrace_card {
    width: 100%;
    height: 100%;
    padding: 12px;
    background-color: black;
    margin-bottom: 4px;
  }
  
  .findyourrace_card_img_div {
    height: 260px;
  }
  
  .findyourrace_card_title {
    font-size: 24px;
    margin-top: 12px;
  }
  
  .findyourrace_card_date {
    font-size: 18px;
    margin-top: 8px;
  }
  
  .findyourrace_card_btns {
    width: 100%;
    justify-content: space-between;
    display: flex;
    margin-bottom: 10px;
  }
  
  .findyourrace_card_btns > button {
    width: 48% !important;
    height: 36px;
    font-size: 16px;
  }
  
  .findyourrace_card_btns > a {
    width: 48% !important;
    height: 36px;
  }
  
  .findyourrace_card_btns > a > button {
    height: 36px;
    font-size: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_img_div {
    height: 260px !important;
  }
  
  .findyourrace_card:hover .findyourrace_card_btns {
    margin-top: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_date {
    display: flex;
  }

}













@media screen and (max-width: 450px) {

  .findyourrace_card {
    width: 100%;
    height: 100%;
    padding: 16px;
    background-color: black;
    margin-bottom: 4px;
  }
  
  .findyourrace_card_img_div {
    height: 260px;
  }
  
  .findyourrace_card_title {
    font-size: 22px;
    margin-top: 12px;
  }
  
  .findyourrace_card_date {
    font-size: 16px;
    margin-top: 8px;
  }
  
  .findyourrace_card_btns {
    width: 100%;
    justify-content: space-between;
    display: flex;
    margin-bottom: 10px;
  }
  
  .findyourrace_card_btns > button {
    width: 48% !important;
    height: 36px;
    font-size: 16px;
  }
  
  .findyourrace_card_btns > a {
    width: 48% !important;
    height: 36px;
  }
  
  .findyourrace_card_btns > a > button {
    height: 36px;
    font-size: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_img_div {
    height: 260px !important;
  }
  
  .findyourrace_card:hover .findyourrace_card_btns {
    margin-top: 16px;
  }
  
  .findyourrace_card:hover .findyourrace_card_date {
    display: flex;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/findYourRace/findYourRaceCard.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,4CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;;AAE5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;;AAE5B;;AAEA;EACE,aAAa;EACb,0BAA0B;;AAE5B;;;;;;;;;;;;;AAaA;;EAEE;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF;;;;;;;;;;;;;AAaA;;EAEE;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF;;;;;;;;;;;;;;;;;;;;AAoBA;;EAEE;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF;;;;;;;;;;;;AAYA;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF;;;;;;;;;;;;;;AAcA;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF","sourcesContent":["@font-face {\n  font-family: mediumThicker;\n  src: url(../../assets/fonts/Thicker-Medium.otf);\n}\n\n.findyourrace_card {\n  width: 305px;\n  height: 339px;\n  flex-shrink: 0;\n  background: #1e1e1e;\n  box-shadow: 0px 0px 62px -6px rgba(0, 0, 0, 0.15);\n  padding: 16px;\n}\n\n.findyourrace_card_img_div {\n  width: 100%;\n  height: 229px;\n}\n\n.findyourrace_card_img_div > img {\n  width: 100%;\n  height: 100%;\n}\n\n.findyourrace_card_title {\n  color: #fff;\n  font-family: Thicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  text-transform: capitalize;\n  margin-top: 12px;\n}\n\n.findyourrace_card_date {\n  color: #fff;\n  font-family: mediumThicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 100%;\n  text-transform: capitalize;\n  margin-top: 8px;\n}\n\n.findyourrace_card_btns {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  display: none;\n  margin-top: 16px;\n}\n\n.findyourrace_card_btns > button {\n  display: flex;\n  width: 131px !important;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  background-color: #000;\n  font-family: mediumThicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  border: 1px solid #fff;\n  cursor: pointer;\n}\n\n.findyourrace_card_btns > a {\n  width: 131px !important;\n  height: 40px;\n  list-style: none;\n  text-decoration: none;\n}\n\n.findyourrace_card_btns > a > button {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  background:#BA1E24;\n  font-family: mediumThicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  border: 1px solid #BA1E24;\n  cursor: pointer;\n}\n\n.findyourrace_card:hover .findyourrace_card_img_div {\n  height: 225px !important;\n  transition: all .2s linear;\n\n}\n\n.findyourrace_card:hover .findyourrace_card_btns {\n  display: flex;\n  margin-top: 12px;\n  transition: all .2s linear;\n\n}\n\n.findyourrace_card:hover .findyourrace_card_date {\n  display: none;\n  transition: all .2s linear;\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n  .findyourrace_card {\n    width: 305px;\n    height: 100%;\n    padding: 16px;\n  }\n  \n  .findyourrace_card_img_div {\n    height: 229px;\n  }\n  \n  .findyourrace_card_title {\n    font-size: 20px;\n    margin-top: 12px;\n  }\n  \n  .findyourrace_card_date {\n    font-size: 16px;\n    margin-top: 8px;\n  }\n  \n  .findyourrace_card_btns {\n    width: 100%;\n    justify-content: space-between;\n    display: flex;\n  }\n  \n  .findyourrace_card_btns > button {\n    width: 131px !important;\n    height: 40px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card_btns > a {\n    width: 131px !important;\n    height: 40px;\n  }\n  \n  .findyourrace_card_btns > a > button {\n    height: 40px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_img_div {\n    height: 229px !important;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_btns {\n    margin-top: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_date {\n    display: flex;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n  .findyourrace_card {\n    width: 300px;\n    height: 100%;\n    padding: 12px;\n  }\n  \n  .findyourrace_card_img_div {\n    height: 229px;\n  }\n  \n  .findyourrace_card_title {\n    font-size: 20px;\n    margin-top: 12px;\n  }\n  \n  .findyourrace_card_date {\n    font-size: 16px;\n    margin-top: 8px;\n  }\n  \n  .findyourrace_card_btns {\n    width: 100%;\n    justify-content: space-between;\n    display: flex;\n    margin-bottom: 10px;\n  }\n  \n  .findyourrace_card_btns > button {\n    width: 131px !important;\n    height: 40px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card_btns > a {\n    width: 131px !important;\n    height: 40px;\n  }\n  \n  .findyourrace_card_btns > a > button {\n    height: 40px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_img_div {\n    height: 229px !important;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_btns {\n    margin-top: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_date {\n    display: flex;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 700px) {\n\n  .findyourrace_card {\n    width: 300px;\n    height: 100%;\n    padding: 12px;\n  }\n  \n  .findyourrace_card_img_div {\n    height: 229px;\n  }\n  \n  .findyourrace_card_title {\n    font-size: 20px;\n    margin-top: 12px;\n  }\n  \n  .findyourrace_card_date {\n    font-size: 16px;\n    margin-top: 8px;\n  }\n  \n  .findyourrace_card_btns {\n    width: 100%;\n    justify-content: space-between;\n    display: flex;\n    margin-bottom: 10px;\n  }\n  \n  .findyourrace_card_btns > button {\n    width: 48% !important;\n    height: 36px;\n    font-size: 14px;\n  }\n  \n  .findyourrace_card_btns > a {\n    width: 48% !important;\n    height: 36px;\n  }\n  \n  .findyourrace_card_btns > a > button {\n    height: 36px;\n    font-size: 14px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_img_div {\n    height: 229px !important;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_btns {\n    margin-top: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_date {\n    display: flex;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .findyourrace_card {\n    width: 100%;\n    height: 100%;\n    padding: 12px;\n    background-color: black;\n    margin-bottom: 4px;\n  }\n  \n  .findyourrace_card_img_div {\n    height: 260px;\n  }\n  \n  .findyourrace_card_title {\n    font-size: 24px;\n    margin-top: 12px;\n  }\n  \n  .findyourrace_card_date {\n    font-size: 18px;\n    margin-top: 8px;\n  }\n  \n  .findyourrace_card_btns {\n    width: 100%;\n    justify-content: space-between;\n    display: flex;\n    margin-bottom: 10px;\n  }\n  \n  .findyourrace_card_btns > button {\n    width: 48% !important;\n    height: 36px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card_btns > a {\n    width: 48% !important;\n    height: 36px;\n  }\n  \n  .findyourrace_card_btns > a > button {\n    height: 36px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_img_div {\n    height: 260px !important;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_btns {\n    margin-top: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_date {\n    display: flex;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .findyourrace_card {\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n    background-color: black;\n    margin-bottom: 4px;\n  }\n  \n  .findyourrace_card_img_div {\n    height: 260px;\n  }\n  \n  .findyourrace_card_title {\n    font-size: 22px;\n    margin-top: 12px;\n  }\n  \n  .findyourrace_card_date {\n    font-size: 16px;\n    margin-top: 8px;\n  }\n  \n  .findyourrace_card_btns {\n    width: 100%;\n    justify-content: space-between;\n    display: flex;\n    margin-bottom: 10px;\n  }\n  \n  .findyourrace_card_btns > button {\n    width: 48% !important;\n    height: 36px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card_btns > a {\n    width: 48% !important;\n    height: 36px;\n  }\n  \n  .findyourrace_card_btns > a > button {\n    height: 36px;\n    font-size: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_img_div {\n    height: 260px !important;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_btns {\n    margin-top: 16px;\n  }\n  \n  .findyourrace_card:hover .findyourrace_card_date {\n    display: flex;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
